import React from "react";
import { Box, Grid, IconButton,useTheme } from "@mui/material";
import { iconList } from "./iconList";
import { tokens } from "../../assets/theme";

export default function IconPicker({ value, onChange, showNoIcon = true }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box>
            <Grid container spacing={1} mt={2}>
                {iconList.map((item) => (
                    <Grid item key={item.id}>
                        <IconButton
                            onClick={() => onChange(item.id)}
                            color={value === item.id ? "primary" : "default"}
                            sx={{ color: value === item.id ? "#799C4A" : "default"}}
                        >
                            {item.icon}
                        </IconButton>
                    </Grid>
                ))} 
            </Grid>
            
            { showNoIcon && <Grid container spacing={1}>
                <Grid item key={0}>
                    <IconButton
                        onClick={() => onChange(0)}
                        color={value === 0 ? "primary" : "default"}
                        sx={{ color: value === 0 ? "#799C4A" : "default"}}
                    >
                        No icon
                    </IconButton>
                </Grid>
            </Grid> }
        </Box>
    );
}